import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { List, ListItem, withStyles } from '@material-ui/core';
import Favorite from '@material-ui/icons/Favorite';
import footerStyle from '../../assets/jss/material-kit-react/components/footerStyle';
function Footer({ ...props }) {
    const { classes, whiteFont } = props;
    const footerClasses = classNames({
        [classes.footer]: true,
        [classes.footerWhiteFont]: whiteFont,
    });
    const aClasses = classNames({
        [classes.a]: true,
        [classes.footerWhiteFont]: whiteFont,
    });
    return (React.createElement("footer", { className: footerClasses },
        React.createElement("div", { className: classes.container },
            React.createElement("div", { className: classes.left },
                React.createElement(List, { className: classes.list },
                    React.createElement(ListItem, { className: classes.inlineBlock },
                        React.createElement("a", { href: "https://www.creative-tim.com/", className: classes.block, target: "_blank" }, "Creative Tim")),
                    React.createElement(ListItem, { className: classes.inlineBlock },
                        React.createElement("a", { href: "https://www.creative-tim.com/presentation", className: classes.block, target: "_blank" }, "About us")),
                    React.createElement(ListItem, { className: classes.inlineBlock },
                        React.createElement("a", { href: "http://blog.creative-tim.com/", className: classes.block, target: "_blank" }, "Blog")),
                    React.createElement(ListItem, { className: classes.inlineBlock },
                        React.createElement("a", { href: "https://www.creative-tim.com/license", className: classes.block, target: "_blank" }, "Licenses")))),
            React.createElement("div", { className: classes.right },
                "\u00A9 ",
                1900 + new Date().getYear(),
                " , made with",
                ' ',
                React.createElement(Favorite, { className: classes.icon }),
                " by",
                ' ',
                React.createElement("a", { href: "https://www.creative-tim.com", className: aClasses, target: "_blank" }, "Creative Tim"),
                ' ',
                "for a better web."))));
}
Footer.propTypes = {
    classes: PropTypes.object.isRequired,
    whiteFont: PropTypes.bool,
};
export default withStyles(footerStyle)(Footer);
//# sourceMappingURL=Footer.js.map